export default __webpack_public_path__ + "static/media/00.2f79f545.jpg";